@if (showTrackings()) {
  <div class="flex flex-col gap-3">
    <span class="text-shikenso-purple-base-60 text-sm">
      {{ 'pages.campaignForm.sections.keywordTracking.description' | translate }}
    </span>

    <app-deliverable-list
      class="keyword-tracking-deliverable-list"
      [formArray]="form.controls.trackings"
      [isGlobalTracking]="true"
      [isAllExpanded]="true"
    />
  </div>
}
